var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDelete(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 34,
    viewBox: "0 0 30 34",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19.5667 12L18.99 27M11.01 27L10.4333 12M27.0467 6.65001C27.6167 6.73668 28.1833 6.82835 28.75 6.92668M27.0467 6.65168L25.2667 29.7883C25.194 30.7304 24.7684 31.6103 24.075 32.2521C23.3816 32.8939 22.4715 33.2503 21.5267 33.25H8.47333C7.52849 33.2503 6.61837 32.8939 5.92497 32.2521C5.23156 31.6103 4.80598 30.7304 4.73333 29.7883L2.95333 6.65001M27.0467 6.65001C25.1231 6.35921 23.1896 6.13851 21.25 5.98835M1.25 6.92501C1.81667 6.82668 2.38333 6.73501 2.95333 6.65001M2.95333 6.65001C4.87689 6.35921 6.81039 6.13851 8.75 5.98835M21.25 5.98835V4.46168C21.25 2.49501 19.7333 0.855014 17.7667 0.793348C15.9227 0.734411 14.0773 0.734411 12.2333 0.793348C10.2667 0.855014 8.75 2.49668 8.75 4.46168V5.98835M21.25 5.98835C17.0895 5.66681 12.9105 5.66681 8.75 5.98835",
    stroke: "black",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDelete);
export default __webpack_public_path__ + "static/media/delete.a0e9007dfc709f75bd8b95d58084b6b1.svg";
export { ForwardRef as ReactComponent };